function Alert({ num }) {
  return <div className="flex justify-center items-center rounded-full bg-[#005DF9] w-[1.4rem] h-[1.4rem] text-white text-[0.7rem]">{num}</div>;
}
export default Alert;
